module.exports = __webpack_public_path__ + "img/8.b51cb1c5.svg";